











import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter, Mutation } from 'vuex-class';
import { Forbidden } from '@/models/forbidden-error';
import { NotFound } from '@/models/not-found-error';
import { ReportApi } from '@/api/report-api';
import reportView from '@/components/reports/report-view.vue';
import { install } from 'vuex';
import { ReportDetailsViewModel } from '@/models/reports/report-details-viewmodel';
import { ActionConstants } from '@/stores/reports/action-constants';

const reportApi = new ReportApi();
const Module = namespace('report');

@Component({
    components: {
        reportView,
    },
})
export default class ViewReport extends Vue {
    public isLoading: boolean = true;
    public report: ReportDetailsViewModel | null = null;

    public async load(): Promise<void> {
        try {
            // TODO(George)- this is a hack
            let reportId: number = 0;
            if (this.$route.params.id) {
                reportId = Number(this.$route.params.id);
            }
            const result = await reportApi.fetchByIdAsync(reportId);
            this.report = new ReportDetailsViewModel(result);
            if (result) {
                this.$store.dispatch(ActionConstants.updateAllReportLogicalOperators, result.logicalOperators);
                this.$store.dispatch(ActionConstants.updateAllReportOperators, result.operators);
                this.$store.dispatch(ActionConstants.updateAllReportBooleanValues, result.booleanValues);
            }
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                this.$router.push({ name: 'not-found' });
            }
        }
    }
    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.load();
        this.isLoading = false;
    }
}

